import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";import { AuthProvider, useAuth } from "@/context/AuthContext";
import { captureAttribution } from "@/lib/api";
import { Navbar, Footer } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ComeFunziona from "@/pages/ComeFunziona";
import { PrivacyPage, TerminiPage, CookiePage } from "@/pages/StaticPages";
import Servizi from "@/pages/Servizi";
import Settori from "@/pages/Settori";
import SettoreDetail from "@/pages/SettoreDetail";
import BusinessCheck from "@/pages/BusinessCheck";
import Benchmark from "@/pages/Benchmark";
import Simulatore from "@/pages/Simulatore";
import BusinessPlan from "@/pages/BusinessPlan";
import QuantoCostaAprire from "@/pages/QuantoCostaAprire";
import { BusinessPlanProfessionalPage as BusinessPlanProfessional, BreakEvenPage as BreakEven, PricingCalculatorPage as PricingCalculator, AiAdvisorPage as AiAdvisor, SimulazioneInvestimentoPage as SimulazioneInvestimento, AperturaNuovaSedePage as AperturaNuovaSede, SimulatoreAssunzionePage as SimulatoreAssunzione } from "@/pages/Tools";
import CashFlow from "@/pages/CashFlow";
import AnalisiFinanziaria from "@/pages/AnalisiFinanziaria";
import AnalisiBilancio from "@/pages/AnalisiBilancio";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Report from "@/pages/Report";
import CFOSimulator from "@/pages/CFOSimulator";
import Azienda from "@/pages/Azienda";
import Impostazioni from "@/pages/Impostazioni";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function Shell() {
  const location = useLocation();
  React.useEffect(() => { captureAttribution(); }, []);
  // Emergent Google OAuth callback: session_id in URL fragment
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const bare = location.pathname.startsWith("/payment/");
  return (
    <div className="min-h-screen flex flex-col bg-[#F4F4F7]">
      {!bare && <Navbar />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/come-funziona" element={<ComeFunziona />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/settori" element={<Settori />} />
          <Route path="/settori/:slug" element={<SettoreDetail />} />
          <Route path="/business-check" element={<BusinessCheck />} />
          <Route path="/benchmark" element={<Benchmark />} />
          <Route path="/simulatore" element={<Simulatore />} />
          <Route path="/business-plan" element={<BusinessPlan />} />
          <Route path="/business-plan-professionale" element={<BusinessPlanProfessional />} />
          <Route path="/quanto-costa-aprire" element={<QuantoCostaAprire />} />
          <Route path="/break-even" element={<BreakEven />} />
          <Route path="/pricing-calculator" element={<PricingCalculator />} />
          <Route path="/ai-advisor" element={<AiAdvisor />} />
          <Route path="/simulazione-investimento" element={<SimulazioneInvestimento />} />
          <Route path="/apertura-nuova-sede" element={<AperturaNuovaSede />} />
          <Route path="/cash-flow" element={<Protected><CashFlow /></Protected>} />
          <Route path="/simulatore-assunzione" element={<SimulatoreAssunzione />} />
          <Route path="/analisi-finanziaria" element={<Protected><AnalisiFinanziaria /></Protected>} />
          <Route path="/analisi-bilancio" element={<Protected><AnalisiBilancio /></Protected>} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/termini" element={<TerminiPage />} />
          <Route path="/cookie" element={<CookiePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard/*" element={<Protected><Dashboard /></Protected>} />
          <Route path="/report" element={<Protected><Report /></Protected>} />
          <Route path="/cfo-simulator" element={<Protected><CFOSimulator /></Protected>} />
          <Route path="/azienda" element={<Protected><Azienda /></Protected>} />
          <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
          <Route path="/admin/*" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <Toaster position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </AuthProvider>
  );
}
